import { render, staticRenderFns } from "./ProjectStatistics.vue?vue&type=template&id=bfb5b4dc"
import script from "./project-statistics.ts?vue&type=script&lang=ts&external"
export * from "./project-statistics.ts?vue&type=script&lang=ts&external"
import style0 from "./project-statistics.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports